import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import SignatureCanvas from 'react-signature-canvas'

import Button from './Button';
import { apiCallBegan } from '../store/api';

function SignaturePad ({ onSave, children, id, type, className, wo, formFields })  {
    const [failure, setFailure] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [saved, setSaved] = useState(false);
    const submittingRef = useRef(false);
    const savedRef = useRef(false);

    const sigCanvas = useRef({});
    let dispatch = useDispatch()

    const clear = () => { sigCanvas.current.clear(); setFailure('') };



    const save = async (without) => {
        if (submittingRef.current || savedRef.current) return
        if (formFields?.release_agreement && sigCanvas.current.isEmpty?.()) {
            setFailure('Please sign the agreement before saving.')
            return
        }
        submittingRef.current = true
        setSubmitting(true)
        setFailure('')
        try {
        let dataurl =sigCanvas.current.getTrimmedCanvas().toDataURL("image/png")
        let arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let croppedImage = new File([u8arr], 'myImage.jpg', { type: mime });
        const formData = new FormData()
        formData.append('myImage', croppedImage)
        Object.entries(formFields || {}).forEach(([name, value]) => { if (typeof value === 'string') formData.append(name, value) })
        let key = await dispatch(apiCallBegan({ url: `/image/${type ||'artistSig'}/${id}`, method: 'POST', data: formData, showSpinner: true, closePop: true, returnErrorData: true }))
        // Never continue to agreement generation after a rejected or failed
        // signature upload. In enforced payment-security cases the server can
        // intentionally return a release block here.
        if (!key?.picture || key?.errorMessage || key?.failed) {
            setFailure(key?.errorMessage || key?.message || 'The signature could not be saved. Please try again.')
            return
        }
        savedRef.current = true
        setSaved(true)
        if(onSave) await onSave(key, without)
        } catch (error) {
            setFailure(savedRef.current ? 'The signature was saved, but this screen could not refresh. Close and reopen the order to check its status; do not sign again.' : error?.response?.data?.errorMessage || error?.message || 'The signature could not be saved. Please try again.')
        } finally {
            submittingRef.current = false
            setSubmitting(false)
        }
      }



    return <div className={className +' subCont signature'} >
        {children}<br/>
        Please sign below with the cursor or your finger.

        <SignatureCanvas canvasProps={{className: 'signature-pad'}}
              ref={sigCanvas}/>


        {failure ? <p role='alert'>{!saved && <strong>Signature was not saved. </strong>}{failure}</p> : null}
        <div className="buttons">

            <Button className='btn-2 highLight ' disabled={submitting || saved} onClick={() => save(false)}>{submitting ? 'Saving signature…' : saved ? 'Signature saved' : failure ? 'Retry signature' : 'Save'}</Button>
            <Button className='btn-2 ' disabled={submitting || saved} onClick={clear}>Clear</Button>
            {wo &&     <Button className='btn-2 ' disabled={submitting || saved} onClick={() => save(true)}>Save WO Signature</Button>        }
        </div>



    </div>
}

export default SignaturePad
